import Debug from "debug";
const debug = Debug("model:actions:drink");

const WATER_LOW_WARNING = 10;

const notification =
  (waterLeft) => (waterLeft <= WATER_LOW_WARNING
    ? `water is running low`
    : null);

const attempt = ({ party: { caravan, resources } }) => {
  const waterNeeded = caravan.drink();
  const waterAvailable = resources.attribs.water.value;

  const result = {
    success: waterNeeded <= waterAvailable,
    cost: {
      water: Math.min(waterAvailable, waterNeeded),
    },
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const { history, resources } = context.party;
  const { cost } = result;

  // Track action
  history.add({ action: "drink", result });

  resources.delta({ water: -cost.water }, context);
  debug(resources.attribs);

  return { notification: notification(resources.attribs.water.value) };
};

// Only enable the action if food is a visible resource
const enabled = ({ party: { resources, phase, city } }) =>
  resources.isVisible(phase, resources.attribs.water) && !city;

const drink = {
  title: "",
  enabled,
  execute: (context) => {
    if (!enabled(context)) {
      debug("Drink action not enabled");
      return null;
    }

    const result = attempt(context);
    const { notification } = executeSideEffects(context, result);

    return { success: result.success, notification };
  },
};

export default drink;
